import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";
import { FetchAccumulatorsData } from "../interfaces/Accumulators";

const getAccumulatorsRoute = ({ serviceIds, onDate, fromDate, toDate }: FetchAccumulatorsData) =>
  buildUrl({
    url: `${baseUrl}/pre-processor-api/agg-usages/search`,
    searchParams: {
      serviceIds,
      onDate,
      fromDate,
      toDate,
    },
  });

export default getAccumulatorsRoute;
